import { Trans } from 'react-i18next'
import { MdPhone } from 'react-icons/md'

import { Layout, Text } from '../../components'
import { useDeviceIdProvider, usePhoneNumber } from '../../hooks'

export function SystemMaintenanceFrame() {
  const { deviceId } = useDeviceIdProvider()
  const { phoneNumber } = usePhoneNumber(deviceId || null)

  return (
    <Layout>
      <div className="mt-[40px] flex w-full flex-col items-center gap-y-[40px] leading-[2]">
        <div>
          <Text size="lg2" weight="bold" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.information"
              tOptions={{ lng: 'ja' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.description1"
              tOptions={{ lng: 'ja' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey={
                phoneNumber
                  ? 'frames.MaintenanceFrame.description2'
                  : 'frames.MaintenanceFrame.phoneNotFound'
              }
              tOptions={{ lng: 'ja' }}
            />
          </Text>
        </div>
        <div>
          <Text size="lg2" weight="bold" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.information"
              tOptions={{ lng: 'en' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.description1"
              tOptions={{ lng: 'en' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey={
                phoneNumber
                  ? 'frames.MaintenanceFrame.description2'
                  : 'frames.MaintenanceFrame.phoneNotFound'
              }
              tOptions={{ lng: 'en' }}
            />
          </Text>
        </div>
        {phoneNumber && (
          <div>
            <Text size="lg6" weight="bold" align="center">
              <MdPhone className="inline relative right-[5px] top-[-3px]" />
              {phoneNumber}
            </Text>
          </div>
        )}
      </div>
    </Layout>
  )
}
